import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Form,
  Select,
  Row,
  Col,
  Checkbox,
  Spin,
  Tooltip,
  Modal,
  Button,
  Divider,
  Input,
  Space,
} from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import InputField from "../../common/htmlComponents/InputField";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, patchRequest } from "../../axios";
import { Option } from "antd/lib/mentions";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { PlusOutlined, PlusSquareFilled } from "@ant-design/icons";
import { t } from "i18next";
import SelectVendorAddModal from "./SelectVendorAddModal";
import PRPopUpDetails from "../PR/PRPopUpDetails";

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

const SelectVendor = () => {
  const { rfqId } = useParams();
  const navigate = useNavigate();
  const [getResponseData, setGetResponseData] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [rfqNumber, setRfqNumber] = useState("");
  const [rendomId, setRendomId] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [showSendButton, setShowSendButton] = useState(false);
  const [rfqSelectId, setRfqSelectId] = useState(null);
  const [rfqFloatId, setRfqFloatId] = useState(null);
  const [apiLoading, setapiLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState("");
  const [rfqVendorId, setRfqVendorId] = useState(null);
  const [getApi, setGetApi] = useState(false);
  const [rfqDetailFloatID, setRfqDetailFloatID] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPr, setIsModalOpenPr] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [prNumberList, setPRNumberList] = useState([]);
  const [statePRDetailsHover, setStatePRDetailsHover] = useState(null);
  const [prNumberHover, setPRNumberHover] = useState(null);
  const [masterId, setMasterId] = useState(null);
  const showModalPr = () => {
    setIsModalOpenPr(true);
  };
  const handleOkPr = () => {
    setIsModalOpenPr(false);
  };
  const handleCancelPr = () => {
    setIsModalOpenPr(false);
  };
  const addNewVendor = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const res = async () => {
    setapiLoading(true);
    try {
      let apiResponse = await getRequest(`rfq-material-details/${rfqId}`);
      console.log("apiResponseds888", apiResponse);

      setGetResponseData(apiResponse.data.data);
      setRfqNumber(apiResponse.data.data.rfq_number);

      const rendomId = apiResponse.data.data.id;
      setRendomId(rendomId);

      setMasterId(apiResponse.data.data.rfq_details[0].id);
      if (
        apiResponse.data.data.purchase_requisition_city_by_pr_number.length > 0
      ) {
        setPRNumberList(
          apiResponse.data.data.purchase_requisition_city_by_pr_number
        );
      }
      setRfqSelectId(apiResponse?.data?.data?.rfq_material_details[0]?.id);
      setRfqVendorId(
        apiResponse?.data?.data?.total_quantity_by_site[0]?.site_wise[0]
          .material_wise[0].vendors_data
      );
      setRfqFloatId(
        apiResponse?.data?.data?.rfq_material_details[0]?.rfq_master
      );
      setRfqDetailFloatID(apiResponse?.data?.data?.rfq_details[0]?.float_rfq);

      const materialDetailsMap = new Map();
      // apiResponse.data.data.material_wise_details.forEach((material) => {
      //   console.log("hhhhhhhh", material);

      //   const key = `${material.purchase_requisition_material_id}`;
      //   materialDetailsMap.set(key, {
      //     material_total_quantity: material.material_total_quantity,
      //     amount: material.amount,
      //     id: material.rfq_material_id
      //   });
      // });
      if (
        apiResponse?.data?.data?.pr_city_wise_by_pr_number &&
        Array.isArray(apiResponse.data.data.pr_city_wise_by_pr_number)
      ) {
        apiResponse.data.data.pr_city_wise_by_pr_number.forEach((cityData) => {
          if (Array.isArray(cityData.city_wise_pr)) {
            cityData.city_wise_pr.forEach((city) => {
              console.log("citydddd22", city);

              city.site_wise_details.forEach((site) => {
                console.log("site", site);

                site.material_wise_details.forEach((material) => {
                  // Log the material being processed
                  console.log("Processing", material);

                  const key = `${material.purchase_requisition_material_id}`;
                  materialDetailsMap.set(key, {
                    material_total_quantity: material.pr_total_quantity,
                    amount: material.pr_total_amount,
                    id: material.rfq_material_id,
                  });
                });
              });
            });
          }
        });
      }

      const initialState = {
        rfq_master: masterId,
        rfq_material_details: apiResponse?.data?.data?.pr_city_wise_by_pr_number
          .map((cityData) => {
            return cityData.city_wise_pr.map((cityDetails) => {
              return cityDetails.site_wise_details.map((siteData) => {
                console.log("siteData444", siteData);

                return {
                  purchase_requisition_site_name: siteData.site_id,
                  site_wise_total_quantity: siteData.site_total_quantity,
                  quantity_in_kg: siteData.site_total_quantity_by_kg,
                  // site_wise_total_amount: siteData.site_total_quantity_by_kg * siteData.material_wise_details.reduce((acc, material) => acc + material.pr_total_amount, 0),
                  site_wise_total_amount: siteData.material_wise_details.reduce(
                    (acc, material) => acc + material.pr_total_amount,
                    0
                  ),

                  rfq_material_wise: siteData.material_wise_details.map(
                    (material) => {
                      console.log("material3333", material);

                      const materialKey = `${material.purchase_requisition_material_id}`;
                      console.log(
                        "materialKeyddd",
                        materialKey,
                        "materialDetailsMap",
                        materialDetailsMap
                      );

                      const matchedMaterial =
                        materialDetailsMap.get(materialKey);

                      console.log("matchedMaterial78", matchedMaterial);

                      return {
                        id: matchedMaterial ? matchedMaterial.id : null, // Adjust as necessary
                        purchase_requisition_material:
                          material.purchase_requisition_material_id,
                        material_total_quantity: matchedMaterial
                          ? matchedMaterial.material_total_quantity
                          : material.pr_total_quantity,
                        amount: matchedMaterial
                          ? matchedMaterial.amount
                          : material.pr_total_amount,
                        material_amount: material.pr_total_amount,
                        material_qty: material.pr_total_quantity,
                        material_uom: material.material_type_uom,
                        vendor:
                          material.is_new_rfq !== true
                            ? material.vendors
                                ?.filter((vendor) => vendor.is_selected_vendor)
                                ?.map((vendor) => vendor.id)
                            : material.vendors?.map((vendor) => vendor.id),
                        // vendor: material.vendors?.map((vendor) => vendor.id),
                        materialInKg: material.pr_total_quantity_by_kg,
                        siteId: siteData.site_id,
                        materialId: material.material_type_name,
                      };
                    }
                  ),
                };
              });
            });
          })
          .flat(), // Flatten the array to get a single level array
      };
      console.log("initialStates66", initialState);

      setapiLoading(false);
      setState(initialState);
    } catch (err) {
      //ErrorNotificationMsg(err);
      setapiLoading(false);
    }
  };

  useEffect(() => {
    res();
    getVendor();
    getCurrency();
  }, [getApi, reload]);

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  // const handleVendorChange = (value, ind, materialTypeIndex, siteIndex) => {
  //   console.log('value', value, 'ind', ind, 'materialTypeIndex', materialTypeIndex, 'siteIndex', siteIndex);

  //   const updatedState = { ...state };
  //   if (
  //     updatedState.rfq_material_details &&
  //     updatedState.rfq_material_details[0]
  //   ) {
  //     updatedState.rfq_material_details[ind].rfq_city_wise[0].rfq_material_wise[
  //       materialTypeIndex
  //     ].rfq_site_wise_vendor[siteIndex].vendor = value;
  //     setState(updatedState);
  //     setSelectedVendors(value);
  //   } else {
  //     console.error("State structure doesn't match expected hierarchy");
  //   }
  // };

  // const handleVendorChange = (value, ind, materialTypeIndex, siteIndex) => {
  //   // console.log(
  //   //   "value",
  //   //   value,
  //   //   "ind",
  //   //   ind,
  //   //   "materialTypeIndex",
  //   //   materialTypeIndex,
  //   //   "siteIndex",
  //   //   siteIndex
  //   // );

  //   const updatedState = { ...state };
  //   if (
  //     updatedState.rfq_material_details &&
  //     updatedState.rfq_material_details[ind] &&
  //     updatedState.rfq_material_details[ind].rfq_city_wise &&
  //     updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex] &&
  //     updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex]
  //       .rfq_material_wise &&
  //     updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex]
  //       .rfq_material_wise[materialTypeIndex]
  //   ) {
  //     // Update the vendor selection
  //     updatedState.rfq_material_details[ind].rfq_city_wise[
  //       siteIndex
  //     ].rfq_material_wise[materialTypeIndex].vendor = value;

  //     // Set the updated state
  //     setState(updatedState);
  //     setSelectedVendors(value);
  //   } else {
  //     console.error(
  //       "State structure doesn't match expected hierarchy or indices are invalid"
  //     );
  //   }
  // };
  const handleShowHoveredPRDetails = (prNumber, statePRDetails) => {
    console.log("Mouse Enter");
    console.log(prNumber, statePRDetails, "PRNUMBER");
    setPRNumberHover(prNumber);
    setStatePRDetailsHover(statePRDetails);
    showModalPr();
    // return (
    //   <PRPopUpDetails prNumber={prNumber} statePRDetails={statePRDetails} />
    // );
  };
  const handleVendorChange = (
    value,
    cityDetailsIndex,
    siteIndex,
    materialData
  ) => {
    console.log(
      "value",
      value,
      "cityDetailsIndex",
      cityDetailsIndex,
      "siteIndex",
      siteIndex,
      "materialData",
      materialData
    );

    setState((prevState) => {
      const updatedState = { ...prevState };

      if (materialData) {
        const { siteId, materialId } = materialData;

        updatedState.rfq_material_details.forEach((city) => {
          city.forEach((site) => {
            site.rfq_material_wise.forEach((material) => {
              console.log("material11111", material);

              if (
                material.siteId === siteId &&
                material.materialId === materialId
              ) {
                console.log(
                  "material2222",
                  material,
                  "siteId",
                  siteId,
                  "materialId",
                  materialId
                );
                material.vendor = value;
              }
            });
          });
        });

        return updatedState;
      } else {
        console.error("Material data is undefined");
        return prevState;
      }
    });

    setSelectedVendors(value);
  };

  const handleCheckboxChange = (ind, siteIndex, checked) => {
    if (checked) {
      const updatedState = { ...state };
      updatedState.rfq_material_details[ind].rfq_site_wise_vendor[
        siteIndex
      ].vendor =
        state?.rfq_material_details[ind]?.rfq_site_wise_vendor[
          siteIndex - 1
        ].vendor;
      setState(updatedState);
    }
  };
  //console.log("getResponseData", getResponseData);

  const createPayload = (state) => {
    console.log("state100", state);

    const payload = {
      rfq_master: masterId,
      rfq_site_details: [],
    };

    state.rfq_material_details.forEach((cityDetails) => {
      cityDetails.forEach((siteDetails) => {
        const sitePayload = {
          purchase_requisition_site_name:
            siteDetails.purchase_requisition_site_name,
          rfq_material_details: [],
        };

        siteDetails.rfq_material_wise.forEach((material) => {
          console.log("material998 ", material);

          const materialPayload = {
            id: material.id,
            material_total_quantity: material.material_qty,
            material_total_quantity_by_kg: material.materialInKg,
            amount: material.amount,
            purchase_requisition_material:
              material.purchase_requisition_material,
            unit_of_measurement: material.material_uom,
            vendor: material.vendor,
          };

          sitePayload.rfq_material_details.push(materialPayload);
        });

        payload.rfq_site_details.push(sitePayload);
      });
    });

    return payload;
  };
  const areAllVendorsSelected = (state) => {
    return state.rfq_material_details
      .flat() // Flatten the array of arrays into a single array of site objects
      .every((site) =>
        site.rfq_material_wise.every((material) => material.vendor.length > 0)
      );
  };

  const handleSubmit = async () => {
    const AllVendorSelected = areAllVendorsSelected(state);
    console.log("AllVendorSelected", AllVendorSelected);
    try {
      const seenEntries = {};

      const payload = createPayload(state);

      // const payload = {
      //   rfq_material_details: state.rfq_material_details.map((item) => ({
      //     rfq_city_wise: item.rfq_city_wise.map((city) => {
      //       console.log("city 10101 ", city);

      //       return {
      //         rfq_material_wise: city.rfq_material_wise
      //           .filter((material) => {
      //             const key = `${city.purchase_requisition_site_name}-${material.purchase_requisition_material}`;

      //             if (seenEntries[key]) {
      //               return false;
      //             }

      //             seenEntries[key] = true;
      //             return true;
      //           })
      //           .map((material) => ({
      //             id: material.id,
      //             purchase_requisition_material:
      //               material.purchase_requisition_material,
      //             material_total_quantity: material.material_total_quantity,
      //             // material_total_quantity: city.site_wise_total_quantity,
      //             amount: material.amount,
      //             unit_of_measurement: material.material_uom,
      //             rfq_site_wise_vendor: [
      //               {
      //                 purchase_requisition_site_name:
      //                   city.purchase_requisition_site_name,
      //                 // site_wise_total_quantity:
      //                 //   material.material_total_quantity,
      //                 site_wise_total_quantity: material.material_qty,
      //                 site_wise_total_amount: material.material_amount,
      //                 vendor: material.vendor,
      //               },
      //             ],
      //           })),
      //       };
      //     }),
      //   })),
      // };

      // const payload = {
      //   rfq_material_details: state.rfq_material_details.map((item) => ({
      //     rfq_city_wise: item.rfq_city_wise.map((city) => ({
      //       rfq_material_wise: city.rfq_material_wise.map((material) => ({
      //         id: material.id, // Directly use id from the material
      //         purchase_requisition_material: material.purchase_requisition_material,
      //         material_total_quantity: material.material_total_quantity,
      //         amount: material.amount,
      //         rfq_site_wise_vendor: city.rfq_material_wise.map((m) => ({
      //           purchase_requisition_site_name: city.purchase_requisition_site_name,
      //           site_wise_total_quantity: city.site_wise_total_quantity,
      //           site_wise_total_amount: city.site_wise_total_amount,
      //           vendor: m.vendor,
      //         })),
      //       })),
      //     })),
      //   })),
      // };

      // const payload = {
      //   rfq_material_details: getResponseData.material_details.map((material) => {
      //     const cityWiseMap = new Map();
      //     material.site_wise.forEach((site) => {
      //       const existingCity = cityWiseMap.get(site.site_id);
      //       if (existingCity) {
      //         existingCity.rfq_material_wise[0].rfq_site_wise_vendor[0].vendor.push(...site.vendors_data.map(vendor => vendor.id));
      //       } else {
      //         cityWiseMap.set(site.site_id, {
      //           rfq_material_wise: [
      //             {
      //               id: material.rfq_material_id,
      //               purchase_requisition_material: material.purchase_requisition_material_id,
      //               material_total_quantity: material.material_total_quantity,
      //               amount: material.amount,
      //               rfq_site_wise_vendor: [
      //                 {
      //                   purchase_requisition_site_name: site.site_id,
      //                   site_wise_total_quantity: site.site_wise_total_quantity,
      //                   site_wise_total_amount: site.site_wise_total_amount,
      //                   vendor: site.vendors_data.map(vendor => vendor.id),
      //                 },
      //               ],
      //             },
      //           ],
      //         });
      //       }
      //     });

      //     return { rfq_city_wise: Array.from(cityWiseMap.values()) };
      //   }),
      // };

      let response;
      setBtnLoading(true);
      if (AllVendorSelected) {
        if (rfqSelectId === null) {
          response = await patchRequest(
            `rfq-material-details/${rfqId}/`,
            payload
          );

          if (response.data.success) {
            setBtnLoading(false);
            navigate(`/request-for-quotation/history`);
          }
        } else {
          response = await patchRequest(
            `rfq-material-details/${rfqId}/`,
            payload
          );

          if (response.data.success) {
            console.log("response.data", response);

            setBtnLoading(false);

            // if(response.data.message){
            //   SuccessNotificationMsg(response.data.message);
            // } else {
            //   ErrorNotificationMsg(response.data.message.message);
            // }

            if (typeof response.data.message === "object") {
              ErrorNotificationMsg(response.data.message.message);
            } else {
              SuccessNotificationMsg(response.data.message);
            }

            // SuccessNotificationMsg("RFQ Approved Successfully. Notification sent to vendor");

            setShowSendButton(true);
            navigate(`/request-for-quotation/history`);
          }
          setBtnLoading(false);
        }
      } else {
        ErrorNotificationMsg("Please select atleast one vendor");
        setapiLoading(false);
        setBtnLoading(false);
      }
    } catch (error) {
      setapiLoading(false);
      setBtnLoading(false);
    }
  };
  const handleSubmitSaveDraft = async () => {
    const payload = {
      rfq_master: rfqId,
      rfq_material_details: state.rfq_material_details.map((item) => ({
        rfq_city_wise: item.rfq_city_wise.map((city) => ({
          rfq_material_wise: city.rfq_material_wise.map((material, index) => ({
            id: getResponseData.rfq_material_details[index].id,
            purchase_requisition_material:
              material.purchase_requisition_material,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor: material.rfq_site_wise_vendor.map((site) => ({
              purchase_requisition_site_name:
                site.purchase_requisition_site_name,
              site_wise_total_quantity: site.site_wise_total_quantity,
              site_wise_total_amount: site.site_wise_total_amount,
              vendor: site.vendor,
            })),
          })),
        })),
      })),
    };

    const payload2 = {
      rfq_master: rfqId,
      rfq_material_details: state.rfq_material_details.map((item) => ({
        rfq_city_wise: item.rfq_city_wise.map((city) => ({
          rfq_material_wise: city.rfq_material_wise.map((material, index) => ({
            id: getResponseData.rfq_material_details[index].id,
            purchase_requisition_material:
              material.purchase_requisition_material,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor: material.rfq_site_wise_vendor.map((site) => ({
              id: site.id,
              purchase_requisition_site_name:
                site.purchase_requisition_site_name,
              site_wise_total_quantity: site.site_wise_total_quantity,
              site_wise_total_amount: site.site_wise_total_amount,
              vendor: site.vendor,
            })),
          })),
        })),
      })),
    };

    try {
      let response;
      if (rfqVendorId === null) {
        response = await patchRequest(
          `rfq-material-details/${rfqFloatId}/create-float-rfq-draft/`,
          payload
        );
      } else {
        response = await patchRequest(
          `rfq-material-details/${rfqFloatId}/create-float-rfq-draft/`,
          payload2
        );
      }
      if (response.data.success) {
        setShowSendButton(true);
        setGetApi((prevState) => !prevState);
        SuccessNotificationMsg("RFQ Successfully Sent");

        navigate(`/request-for-quotation/history`);
      }
    } catch (error) {
      setapiLoading(false);
    }
  };

  const getVendor = async (data) => {
    await getRequest("rfq-material-details/get-vendor-by-company/", data).then(
      (response) => {
        setDropdownOptions(response.data.results.data);
      }
    );
  };

  //console.log("state", state);

  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>RFQ - Select Vendor</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link
                  to={`/request-for-quotation/rfq-material-details/${rendomId}`}
                >
                  RFQ - Material Details
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>RFQ - Select Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody selectvendor">
          <Spin spinning={apiLoading}>
            <Form onFinish={handleSubmit}>
              <Row gutter={16}>
                <Col className="TextFeild gutter-row">
                  <Space>
                    <label className="cp">RFQ Number</label>
                    <strong>{rfqNumber}</strong>
                  </Space>
                </Col>
                <Col
                  className="TextFeild gutter-row"
                  style={{ width: "95%", justifyItems: "end" }}
                >
                  <h5 className="rfq-number new">
                    PR Number :{" "}
                    {prNumberList.map((prNumber, index) => {
                      console.log("INDEX,PR NUMBER", index, prNumber);
                      return (
                        <>
                          <span
                            key={index}
                            onMouseEnter={() => {
                              handleShowHoveredPRDetails(
                                prNumber?.pr_number,
                                prNumber?.data
                              );
                            }}
                            style={{
                              marginRight: "30px",
                              cursor: "pointer",
                            }}
                          >
                            {prNumber?.pr_number}
                          </span>
                        </>
                      );
                    })}
                  </h5>
                </Col>
              </Row>

              <div className="formtable">
                <Row gutter={16} className="throw">
                  <Col style={{ width: "55px" }}>
                    <label className="th">Sr.</label>
                  </Col>
                  <Col style={{ width: "120px" }}>
                    <label className="th">City</label>
                  </Col>
                  <Col style={{ width: "100px" }}>
                    <label className="th">Site</label>
                  </Col>

                  <Col style={{ width: "80px" }}>
                    <label className="th">Item </label>
                  </Col>
                  <Col style={{ width: "80px" }}>
                    <Tooltip
                      color="#094E8F"
                      placement="top"
                      title={<span style={{ color: "#fff" }}>Quantity</span>}
                    >
                      <label
                        className="th"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        Qty.
                      </label>
                    </Tooltip>
                  </Col>

                  <Col
                    style={{ width: "120px" }}
                    className="TextFeild gutter-row"
                  >
                    <Tooltip
                      color="#094E8F"
                      placement="top"
                      title={
                        <span style={{ color: "#fff" }}>
                          Unit Of Measurement
                        </span>
                      }
                    >
                      <label className="th">UoM.</label>
                    </Tooltip>
                  </Col>
                  <Col style={{ width: "110px" }}>
                    <Tooltip
                      color="#094E8F"
                      placement="top"
                      title={
                        <span style={{ color: "#fff" }}>Quantity in KG</span>
                      }
                    >
                      <label
                        className="th"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        Qty. in Kg
                      </label>
                    </Tooltip>
                  </Col>
                  <Col
                    style={{
                      width: "140px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                    className="TextFeild gutter-row"
                  >
                    <Tooltip
                      color={["#094E8F"]}
                      placement="top"
                      title={
                        <span style={{ color: "#fff" }}>Estimated Amount</span>
                      }
                    >
                      <label className="th">Est. Amount</label>
                    </Tooltip>
                  </Col>
                  <Col
                    className="TextFeild gutter-row"
                    style={{ width: "440px" }}
                  >
                    {" "}
                    <Tooltip
                      color="#094E8F"
                      placement="top"
                      title={
                        <span style={{ color: "#fff" }}>
                          Add Bidder by typing the name from the vendor database
                        </span>
                      }
                    >
                      <label className="th">Bidder(s)</label>
                    </Tooltip>
                  </Col>
                  <Col>
                    <label className="th">Remark </label>
                  </Col>
                </Row>
                {
                  // <React.Fragment>
                  //   {getResponseData.total_quantity_by_site &&
                  //     getResponseData.total_quantity_by_site.map(
                  //       (data, ind) => {
                  //         // Iterate through each site in site_wise
                  //         return data.site_wise.map((siteData, siteIndex) => {
                  //           // Create a map to group materials by material type name
                  //           const materialMap = {};

                  //           siteData.material_wise.forEach((material) => {
                  //             if (
                  //               !materialMap[
                  //                 material
                  //                   .purchase_requisition_material_type_name
                  //               ]
                  //             ) {
                  //               materialMap[
                  //                 material.purchase_requisition_material_type_name
                  //               ] = [];
                  //             }
                  //             materialMap[
                  //               material.purchase_requisition_material_type_name
                  //             ].push(material);
                  //           });

                  //           return Object.entries(materialMap).map(
                  //             (
                  //               [materialTypeName, materials],
                  //               materialTypeIndex
                  //             ) => (
                  //               <React.Fragment
                  //                 key={`${siteData.site_id}-${materialTypeIndex}`}
                  //               >
                  //                 {materials.map(
                  //                   (materialData, materialDataIndex) => (
                  //                     <React.Fragment
                  //                       key={`material-${materialData.purchase_requisition_material_id}-${materialDataIndex}`}
                  //                     >
                  //                       <Row gutter={16}>
                  //                         <Col
                  //                           style={{ width: "55px" }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           {siteIndex === 0 &&
                  //                             materialTypeIndex === 0 && (
                  //                               <span>{ind + 1}</span>
                  //                             )}
                  //                         </Col>

                  //                         <Col
                  //                           style={{ width: "120px" }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           {siteIndex === 0 &&
                  //                             materialTypeIndex === 0 && (
                  //                               <span>
                  //                                 {data.site_wise_city_name}
                  //                               </span>
                  //                             )}
                  //                         </Col>

                  //                         <Col
                  //                           style={{ width: "100px" }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           {materialTypeIndex === 0 && (
                  //                             <span>{siteData.site_name}</span>
                  //                           )}
                  //                         </Col>
                  //                         <Col
                  //                           style={{ width: "80px" }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           <span>{materialTypeName}</span>
                  //                         </Col>

                  //                         <Col
                  //                           style={{
                  //                             width: "80px",
                  //                             display: "flex",
                  //                             justifyContent: "flex-end",
                  //                             alignItems: "flex-start",
                  //                           }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           <span>
                  //                             {materialData.material_total_quantity?.toLocaleString(
                  //                               "en-IN",
                  //                               { maximumFractionDigits: 2 }
                  //                             )}
                  //                           </span>
                  //                         </Col>

                  //                         <Col
                  //                           style={{ width: "50px" }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           <span>
                  //                             {materialData.unit_of_measurement}
                  //                           </span>
                  //                         </Col>
                  //                         <Col
                  //                           style={{
                  //                             width: "110px",
                  //                             display: "flex",
                  //                             justifyContent: "flex-end",
                  //                             alignItems: "flex-start",
                  //                           }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           <span>
                  //                             {materialData.material_total_quantity_by_kg?.toLocaleString(
                  //                               "en-IN",
                  //                               { maximumFractionDigits: 2 }
                  //                             )}
                  //                           </span>
                  //                         </Col>

                  //                         <Col
                  //                           style={{
                  //                             width: "110px",
                  //                             display: "flex",
                  //                             justifyContent: "flex-end",
                  //                             alignItems: "flex-start",
                  //                           }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           <span>{`${currencySymbol} ${materialData.amount.toLocaleString(
                  //                             "en-IN",
                  //                             { maximumFractionDigits: 2 }
                  //                           )}`}</span>
                  //                         </Col>

                  //                         <Col
                  //                           className="TextFeild gutter-row"
                  //                           style={{ width: "440px" }}
                  //                         >
                  //                           <Select
                  //                             mode="multiple"
                  //                             allowClear
                  //                             showSearch
                  //                             style={{ width: "420px" }}
                  //                             placeholder="Please select"
                  //                             value={
                  //                               state?.rfq_material_details?.[
                  //                                 ind
                  //                               ]?.rfq_city_wise?.[siteIndex]
                  //                                 ?.rfq_material_wise?.[
                  //                                 materialTypeIndex
                  //                               ]?.vendor || []
                  //                             }
                  //                             onChange={(value) =>
                  //                               handleVendorChange(
                  //                                 value,
                  //                                 ind,
                  //                                 materialTypeIndex,
                  //                                 siteIndex
                  //                               )
                  //                             }
                  //                             filterOption={(input, option) =>
                  //                               (option?.children ?? "")
                  //                                 .toLowerCase()
                  //                                 .includes(input.toLowerCase())
                  //                             }
                  //                           >
                  //                             {materialData.vendors_data.map(
                  //                               (vendor) => (
                  //                                 <Option
                  //                                   key={vendor.id}
                  //                                   value={vendor.id}
                  //                                 >
                  //                                   {vendor.name}
                  //                                 </Option>
                  //                               )
                  //                             )}
                  //                           </Select>
                  //                         </Col>
                  //                         <Col
                  //                           // style={{ width: "150px" }}
                  //                           className="TextFeild gutter-row"
                  //                         >
                  //                           {getResponseData.pr_remarks.map(
                  //                             (re, i) =>
                  //                               re.pr_type_name ===
                  //                                 materialTypeName && (
                  //                                 <span key={i}>
                  //                                   {re.pr_remark}
                  //                                 </span>
                  //                               )
                  //                           )}
                  //                         </Col>
                  //                         {/*
                  //                         <Col
                  //                           className="TextFeild gutter-row"
                  //                           style={{ width: "65px" }}
                  //                         >
                  //                           <Tooltip
                  //                             color={colors}
                  //                             placement="right"
                  //                             title={
                  //                               <span style={{ color: "#fff" }}>
                  //                                 Add Vendor
                  //                               </span>
                  //                             }
                  //                           >
                  //                             <Button
                  //                               type="text"
                  //                               icon={<PlusOutlined />}
                  //                               onClick={addNewVendor}
                  //                             ></Button>
                  //                           </Tooltip>
                  //                         </Col> */}
                  //                       </Row>
                  //                     </React.Fragment>
                  //                   )
                  //                 )}
                  //               </React.Fragment>
                  //             )
                  //           );
                  //         });
                  //       }
                  //     )}
                  // </React.Fragment>

                  <React.Fragment>
                    {getResponseData.pr_city_wise_by_pr_number &&
                      getResponseData.pr_city_wise_by_pr_number.map(
                        (cityData, cityIndex) => {
                          return cityData.city_wise_pr.map(
                            (cityDetails, cityDetailsIndex) => {
                              return cityDetails.site_wise_details.map(
                                (siteData, siteIndex) => {
                                  const materialMap = {};

                                  siteData.material_wise_details.forEach(
                                    (material) => {
                                      console.log("materialf555", material);
                                      const key = `${material.material_type_name}-${siteData.site_id}`;
                                      if (!materialMap[key]) {
                                        materialMap[key] = {
                                          ...material,
                                          pr_total_quantity: 0,
                                          pr_total_quantity_by_kg: 0,
                                          pr_total_amount: 0,
                                        };
                                      }
                                      if (
                                        material.material_type_sub_category ===
                                        "RMC"
                                      ) {
                                        materialMap[key].pr_total_quantity +=
                                          material.pr_total_quantity;
                                        materialMap[
                                          key
                                        ].pr_total_quantity_by_kg +=
                                          material.pr_total_quantity_by_kg;
                                        materialMap[key].pr_total_amount +=
                                          material.estimated_material_unit_price *
                                          material.pr_total_quantity;
                                      } else {
                                        materialMap[key].pr_total_quantity +=
                                          material.pr_total_quantity;
                                        materialMap[
                                          key
                                        ].pr_total_quantity_by_kg +=
                                          material.pr_total_quantity_by_kg;
                                        materialMap[key].pr_total_amount +=
                                          material.pr_total_amount;
                                      }
                                    }
                                  );

                                  console.log("state333", materialMap);

                                  return Object.values(materialMap).map(
                                    (materialData, materialDataIndex) => (
                                      <Row
                                        gutter={16}
                                        key={`material-${materialData.purchase_requisition_material_id}-${materialDataIndex}`}
                                      >
                                        <Col
                                          style={{ width: "55px" }}
                                          className="TextFeild gutter-row"
                                        >
                                          {siteIndex === 0 &&
                                            materialDataIndex === 0 && (
                                              <span>
                                                {cityDetailsIndex + 1}
                                              </span>
                                            )}
                                        </Col>

                                        <Col
                                          style={{ width: "120px" }}
                                          className="TextFeild gutter-row"
                                        >
                                          {siteIndex === 0 &&
                                            materialDataIndex === 0 && (
                                              <span>
                                                {cityDetails.city_name}
                                              </span>
                                            )}
                                        </Col>

                                        <Col
                                          style={{ width: "100px" }}
                                          className="TextFeild gutter-row"
                                        >
                                          {materialDataIndex === 0 && (
                                            <span>{siteData.site_name}</span>
                                          )}
                                        </Col>

                                        <Col
                                          style={{ width: "80px" }}
                                          className="TextFeild gutter-row"
                                        >
                                          <span>
                                            {materialData.material_type_name}
                                          </span>
                                        </Col>

                                        <Col
                                          style={{
                                            width: "80px",
                                            textAlign: "end",
                                            //  display: "flex", justifyContent: "flex-end"
                                          }}
                                          className="TextFeild gutter-row"
                                        >
                                          <span>
                                            {materialData.pr_total_quantity?.toLocaleString(
                                              "en-IN",
                                              { maximumFractionDigits: 2 }
                                            )}
                                          </span>
                                        </Col>

                                        <Col
                                          style={{ width: "120px" }}
                                          className="TextFeild gutter-row"
                                        >
                                          <span>
                                            {
                                              materialData.material_type_uom_name
                                            }
                                          </span>
                                        </Col>

                                        <Col
                                          style={{
                                            width: "110px",
                                            textAlign: "end",
                                            //  display: "flex", justifyContent: "flex-end"
                                          }}
                                          className="TextFeild gutter-row"
                                        >
                                          <span>
                                            {materialData.pr_total_quantity_by_kg?.toLocaleString(
                                              "en-IN",
                                              { maximumFractionDigits: 2 }
                                            )}
                                          </span>
                                        </Col>

                                        <Col
                                          style={{
                                            width: "140px",
                                            textAlign: "end",
                                            // display: "flex", justifyContent: "flex-end"
                                          }}
                                          className="TextFeild gutter-row"
                                        >
                                          <span>
                                            {`${currencySymbol} ${materialData.pr_total_amount.toLocaleString(
                                              "en-IN",
                                              { maximumFractionDigits: 2 }
                                            )}`}
                                          </span>
                                        </Col>
                                        <Col
                                          className="TextFeild gutter-row"
                                          style={{ width: "440px" }}
                                        >
                                          <Select
                                            mode="multiple"
                                            allowClear
                                            showSearch
                                            style={{ width: "420px" }}
                                            placeholder="Please select"
                                            value={
                                              state?.rfq_material_details?.[
                                                cityDetailsIndex
                                              ]?.[siteIndex]
                                                ?.rfq_material_wise?.[
                                                materialDataIndex
                                              ]?.vendor || []
                                            }
                                            onChange={(value) =>
                                              handleVendorChange(
                                                value,
                                                cityDetailsIndex,
                                                siteIndex,
                                                state?.rfq_material_details?.[
                                                  cityDetailsIndex
                                                ]?.[siteIndex]
                                                  ?.rfq_material_wise?.[
                                                  materialDataIndex
                                                ]
                                              )
                                            }
                                            filterOption={(input, option) =>
                                              (option?.children ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                          >
                                            {materialData.vendors.map(
                                              (vendor) => (
                                                <Select.Option
                                                  key={vendor.id}
                                                  value={vendor.id}
                                                >
                                                  {vendor.name}
                                                </Select.Option>
                                              )
                                            )}
                                          </Select>
                                        </Col>
                                        <Col
                                          style={{
                                            width: "110px",
                                            //  display: "flex", justifyContent: "flex-end"
                                          }}
                                          className="TextFeild gutter-row"
                                        >
                                          <span>
                                            {materialData?.remark?.toLocaleString(
                                              "en-IN",
                                              { maximumFractionDigits: 2 }
                                            )}
                                          </span>
                                        </Col>
                                      </Row>
                                    )
                                  );
                                }
                              );
                            }
                          );
                        }
                      )}
                  </React.Fragment>

                  // <React.Fragment>
                  //   {getResponseData.pr_city_wise_by_pr_number &&
                  //     getResponseData.pr_city_wise_by_pr_number.map((cityData, cityIndex) => {
                  //       // Iterate through each city in city_wise_pr
                  //       return cityData.city_wise_pr.map((cityDetails, cityDetailsIndex) => {
                  //         return cityDetails.site_wise_details.map((siteData, siteIndex) => {
                  //           // Create a map to group materials by material type name
                  //           const materialMap = {};

                  //           siteData.material_wise_details.forEach((material) => {
                  //             if (!materialMap[material.material_type_name]) {
                  //               materialMap[material.material_type_name] = [];
                  //             }
                  //             materialMap[material.material_type_name].push(material);
                  //           });

                  //           // Render material data grouped by material type
                  //           return Object.entries(materialMap).map(
                  //             ([materialTypeName, materials], materialTypeIndex) => (
                  //               <React.Fragment
                  //                 key={`${siteData.site_id}-${materialTypeIndex}`}
                  //               >
                  //                 {materials.map((materialData, materialDataIndex) => (
                  //                   <React.Fragment
                  //                     key={`material-${materialData.purchase_requisition_material_id}-${materialDataIndex}`}
                  //                   >
                  //                     <Row gutter={16}>
                  //                       {/* Index Column */}
                  //                       <Col
                  //                         style={{ width: "55px" }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         {siteIndex === 0 && materialTypeIndex === 0 && (
                  //                           <span>{cityIndex + 1}</span>
                  //                         )}
                  //                       </Col>

                  //                       {/* City Name */}
                  //                       <Col
                  //                         style={{ width: "120px" }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         {siteIndex === 0 && materialTypeIndex === 0 && (
                  //                           <span>{cityDetails.city_name}</span>
                  //                         )}
                  //                       </Col>

                  //                       {/* Site Name */}
                  //                       <Col
                  //                         style={{ width: "100px" }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         {materialTypeIndex === 0 && (
                  //                           <span>{siteData.site_name}</span>
                  //                         )}
                  //                       </Col>

                  //                       {/* Material Type */}
                  //                       <Col
                  //                         style={{ width: "80px" }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         <span>{materialTypeName}</span>
                  //                       </Col>

                  //                       {/* Quantity */}
                  //                       <Col
                  //                         style={{
                  //                           width: "80px",
                  //                           display: "flex",
                  //                           justifyContent: "flex-end",
                  //                         }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         <span>
                  //                           {materialData.pr_total_quantity?.toLocaleString(
                  //                             "en-IN",
                  //                             { maximumFractionDigits: 2 }
                  //                           )}
                  //                         </span>
                  //                       </Col>

                  //                       {/* Unit of Measurement */}
                  //                       <Col
                  //                         style={{ width: "50px" }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         <span>{materialData.material_type_uom_name}</span>
                  //                       </Col>

                  //                       {/* Quantity by KG */}
                  //                       <Col
                  //                         style={{
                  //                           width: "110px",
                  //                           display: "flex",
                  //                           justifyContent: "flex-end",
                  //                         }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         <span>
                  //                           {materialData.pr_total_quantity_by_kg?.toLocaleString(
                  //                             "en-IN",
                  //                             { maximumFractionDigits: 2 }
                  //                           )}
                  //                         </span>
                  //                       </Col>

                  //                       {/* Total Amount */}
                  //                       <Col
                  //                         style={{
                  //                           width: "110px",
                  //                           display: "flex",
                  //                           justifyContent: "flex-end",
                  //                         }}
                  //                         className="TextFeild gutter-row"
                  //                       >
                  //                         <span>
                  //                           {`${currencySymbol} ${materialData.pr_total_amount.toLocaleString(
                  //                             "en-IN",
                  //                             { maximumFractionDigits: 2 }
                  //                           )}`}
                  //                         </span>
                  //                       </Col>

                  //                       {/* <Col className="TextFeild gutter-row" style={{ width: "440px" }}>
                  //                         <Select
                  //                           mode="multiple"
                  //                           allowClear
                  //                           showSearch
                  //                           style={{ width: "420px" }}
                  //                           placeholder="Please select"
                  //                           value={
                  //                             state?.rfq_material_details?.[cityIndex]?.rfq_city_wise?.[
                  //                               siteIndex
                  //                             ]?.rfq_material_wise?.[materialTypeIndex]?.vendor || []
                  //                           }
                  //                           onChange={(value) =>
                  //                             handleVendorChange(value, cityIndex, materialTypeIndex, siteIndex)
                  //                           }
                  //                           filterOption={(input, option) =>
                  //                             (option?.children ?? "")
                  //                               .toLowerCase()
                  //                               .includes(input.toLowerCase())
                  //                           }
                  //                         >
                  //                           {materialData.vendors_data.map((vendor) => (
                  //                             <Select.Option key={vendor.id} value={vendor.id}>
                  //                               {vendor.name}
                  //                             </Select.Option>
                  //                           ))}
                  //                         </Select>
                  //                       </Col>

                  //                       <Col className="TextFeild gutter-row">
                  //                         {getResponseData.pr_remarks.map(
                  //                           (remark, remarkIndex) =>
                  //                             remark.pr_type_name === materialTypeName && (
                  //                               <span key={remarkIndex}>{remark.pr_remark}</span>
                  //                             )
                  //                         )}
                  //                       </Col> */}

                  //                     </Row>
                  //                   </React.Fragment>
                  //                 ))}
                  //               </React.Fragment>
                  //             )
                  //           );
                  //         });
                  //       });
                  //     })}
                  // </React.Fragment>
                }
                <Col>
                  <Modal
                    width={"60%"}
                    title={t("Add Vendor Details")}
                    open={isModalOpen}
                    footer={[]}
                    wrapClassName="modal-wrapper"
                    visible={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                  >
                    <SelectVendorAddModal
                      handleCancel={handleCancel}
                      setReload={setReload}
                      reload={reload}
                    />
                  </Modal>
                </Col>
              </div>
              <div className="btnwrp2 mt-3">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  label="Previous"
                  onClick={() =>
                    navigate(
                      `/request-for-quotation/rfq-material-details/${rendomId}`
                    )
                  }
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  loading={btnLoading}
                  label="Save & Send RFQ For Approval"
                />
              </div>
            </Form>
          </Spin>
        </div>
      </section>
      <Modal
        className="ModelPopupSecPopUpPRDetails"
        title={`PR Details - ${prNumberHover}`}
        open={isModalOpenPr}
        onOk={handleOkPr}
        onCancel={handleCancelPr}
        closable={handleCancelPr}
        // wrapClassName="modal-wrapper"
        keyboard={true}
        width={"60%"}
      >
        <PRPopUpDetails statePRDetails={statePRDetailsHover} />
      </Modal>
    </>
  );
};

export default SelectVendor;
